import { useMemo } from 'react';

import { IHeatIndexScale } from '../../../types/heatIndex';
import { useApplicationContext } from '../../ApplicationContext';

export function useHeatIndexScale(): IHeatIndexScale[] {
  const { config } = useApplicationContext();

  return useMemo<IHeatIndexScale[]>(() => {
    const scales = config.get<IHeatIndexScale[]>('heatIndexScaleV2') || [];

    return scales.map((scale, index) => ({
      ...scale,
      range: [Math.max(scale.range[0], 1), scale.range[1] - Number(scales.length - 1 > index)],
    }));
  }, [config]);
}
